import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizSessionResultHeader;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Heading } from '@instructure/ui-heading';
import { Alert } from '@instructure/ui-alerts';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var QuizSessionResultHeader = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizSessionResultHeader = /*#__PURE__*/function (_Component) {
  function QuizSessionResultHeader() {
    var _this2;
    _classCallCheck(this, QuizSessionResultHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, QuizSessionResultHeader, [].concat(args));
    _defineProperty(_this2, "renderRegradeAlert", function () {
      if (_this2.props.regradedSessionItemResults && _this2.props.regradedSessionItemResults.size > 0) {
        var questions = _this2.props.regradedSessionItemResults.map(function (rsi) {
          return rsi.position;
        }).toJS().join(', ');
        return jsx(Alert, {
          variant: "warning"
        }, t("This assessment has been regraded. {\n              numRegradedSI, plural,\n                   =1 {Question {questions} has been affected.}\n                other {Questions {questions} have been affected.}\n              }", {
          questions: questions,
          numRegradedSI: _this2.props.regradedSessionItemResults.count()
        }));
      }
    });
    return _this2;
  }
  _inherits(QuizSessionResultHeader, _Component);
  return _createClass(QuizSessionResultHeader, [{
    key: "studentName",
    value: function studentName() {
      return this.props.quizSession.userDisplayName();
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, jsx("div", {
        css: this.props.styles.resultListHeading
      }, jsx("div", {
        css: this.props.styles.resultListInfo
      }, jsx("div", {
        css: this.props.styles.resultListTitle,
        "data-automation": "sdk-result-list-title"
      }, jsx(Heading, {
        level: "h1"
      }, t('Results'))), jsx("div", {
        css: this.props.styles.resultListDescription,
        className: "fs-mask"
      }, this.props.studentDescription || this.studentName()))), jsx("div", {
        css: this.props.styles.regradeAlert
      }, this.renderRegradeAlert()));
    }
  }]);
}(Component), _defineProperty(_QuizSessionResultHeader, "displayName", 'QuizSessionResultHeader'), _defineProperty(_QuizSessionResultHeader, "componentId", "Quizzes".concat(_QuizSessionResultHeader.displayName)), _defineProperty(_QuizSessionResultHeader, "propTypes", {
  quizSession: ImmutablePropTypes.record.isRequired,
  regradedSessionItemResults: ImmutablePropTypes.list,
  studentDescription: PropTypes.node,
  styles: PropTypes.object
}), _defineProperty(_QuizSessionResultHeader, "defaultProps", {
  regradedSessionItemResults: null,
  studentDescription: null
}), _QuizSessionResultHeader)) || _class);
export default QuizSessionResultHeader;